import { createContext, useContext, useState, useEffect } from "react";

const SeniorModeContext = createContext({ seniorMode: false, toggleSenior: () => {}, isSeniorAdmin: false });

const SENIOR_ADMIN_MOBILE = "9811117751";

export function SeniorModeProvider({ children }) {
  const [seniorMode, setSeniorMode] = useState(() => localStorage.getItem("seniorMode") === "true");
  const [isSeniorAdmin, setIsSeniorAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = () => {
      try {
        const raw = localStorage.getItem("customer");
        if (raw) {
          const cust = JSON.parse(raw);
          setIsSeniorAdmin(cust?.mobile === SENIOR_ADMIN_MOBILE);
        }
      } catch {}
    };
    checkAdmin();
    window.addEventListener("storage", checkAdmin);
    return () => window.removeEventListener("storage", checkAdmin);
  }, []);

  useEffect(() => {
    localStorage.setItem("seniorMode", seniorMode);
    if (seniorMode) {
      document.documentElement.classList.add("senior-mode");
    } else {
      document.documentElement.classList.remove("senior-mode");
    }
  }, [seniorMode]);

  const toggleSenior = () => setSeniorMode(p => !p);

  return (
    <SeniorModeContext.Provider value={{ seniorMode, toggleSenior, isSeniorAdmin }}>
      {children}
    </SeniorModeContext.Provider>
  );
}

export function useSeniorMode() {
  return useContext(SeniorModeContext);
}
